module.exports = __webpack_public_path__ + "static/media/inbox.67cab6a4.svg";